import React from 'react'

const Zapprofessional = () => {
  return (
    <div className="w-1/12 bg-amber-500">Zapbooking</div>
  )
}

export default Zapprofessional